const blog = (actualizar: () => void) => {
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement,
            verMas = target.closest('.blog__ver-mas') as HTMLElement,
            blog = target.closest('.blog--completo') as HTMLElement;

        if (target.nodeName !== 'A' || !verMas || !blog || target.classList.contains('blog__ver-mas--cargando')) {
            return;
        }

        const entradas = blog.querySelector('.blog__entradas') as HTMLElement;

        verMas.classList.add('blog__ver-mas--cargando');

        fetch(target.getAttribute('href')!)
            .then(response => response.text())
            .then(data => new DOMParser().parseFromString(data, 'text/html'))
            .then(doc => ({
                nuevasEntradas: doc.querySelectorAll('.blog__entrada'),
                nuevoVerMas: doc.querySelector('.blog__ver-mas a')
            }))
            .then(({nuevasEntradas, nuevoVerMas}) => {
                nuevasEntradas.forEach(entradas.appendChild.bind(entradas));

                if (nuevoVerMas) {
                    target.setAttribute('href', nuevoVerMas.getAttribute('href')!);
                } else {
                    verMas.remove();
                }
            })
            .finally(() => {
                verMas.classList.remove('blog__ver-mas--cargando');

                actualizar();
            });

        e.preventDefault();
    });
}

export default blog;